<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3rbvv8/tc-custom/9781459237469.jpg?1743852190306" alt="This image is the cover for the book Maximum Security"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maximum Security
      </h1>
      <p class="bookDescription body article font2">
        <b>BREAKING DOWN THE WALLS</b><br/><br/>She was the sole survivor of the deadly game of a serial killera man who’d ensnared women and eluded police for far too long. And since her daring escape from his evil clutches, ex-cop and bestselling crime writer Maggie Reyes had remained locked in her beach house, paralyzed with fear until “the Surgeon” was caught.<br/><br/>Then Billy Corrigan came to her, demanding her help. For the sexy FBI agent, catching “the Surgeon” wasn’t just a job, it was personal. So Maggie reluctantly agreed to work with him, but soon found renewed strength wrapped in Billy’s arms. And as the killer closed in, Billy swore he’d lay his own life on the line if it meant freeing beautiful Maggie from her self-made prison.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tracy Montoya
      </h2>
      
      <p class="authorDescription body article">Tracy Montoya lives in Wisconsin with two slightly crazed cats, a husband who&#39;s turned their home into the Island of Lost/Broken/Strange Antiques, and their two daughters. Her books have won the Daphne, the Beacon, and the Golden Quill awards for romantic suspense. A journalist and magazine editor by day, Tracy likes to scuba dive, forget to go to spinning class, wallow in bed with a book, or get out her guitar and pretend she&#39;s Suzanne Vega. Find her online at tracymontoya.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cc0b335